import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { observer, useStore } from '@/hooks/storeHooks'
import st from './index.scss'
import { makeAutoObservable } from 'mobx'
import { Link } from '@/components'
import CountDown from '@/components/CountDown'
import { useRequest } from 'ahooks'
import { productRefresh } from '@/components/product/api'

class productStore {
    constructor() {
        makeAutoObservable(this)
    }
    mybusinessType = window.location.pathname.startsWith('/fakao') ? 'fakao' : 'fashuo'
    // 商品详情
    product_info = {};

    // 修改商品详情
    setProductInfo = (e) => {
        this.product_info = e;
    }

    // 修改分页数据
    setPagination = (e) => {
        this.pagination = e;
    }
}

// 商品名称tag
function productTag(item) {
    const { activityModel, activityType, activityStatus, noticeSaleFlag, presellTag } = item?.activityEntity || {};

    // activityModel  活动方式 2拼团活动 3限时限量 10 定金活动
    // activityType  '1限时，2限量，3限时限量，默认限时' 拼团类型  1-普通拼团
    // activityStatus 1-进行中  2-预约中  3-未开始; activityModel == 10 : 1进行中(定金期) 2预约中 3未开始
    // noticeSaleFlag （false不可售 true可售）

    if (activityStatus == 2 && noticeSaleFlag) { // 预约中 & 预售期不可售
        return '';
    } else if (activityModel == 2) {
        return <span className={st['pintuan_tag']}>{item.activityEntity?.delegationNumMsg}</span>
    } else if (activityModel == 3) {
        return <span className={cn({
            [st['active_tag']]: true,
            [st['active_start']]: activityStatus != '2',
        })}>{activityType == 1 ? '限时优惠' : (activityType == 2 ? '限量优惠' : '限时限量')}</span>
    } else if ( activityModel == 10 && presellTag) {
        return <div className={cn({
            [st['yu_yue_active_tag']]: true,
        })}>
            <img src={presellTag} alt="" />
        </div>
    }
}

// 拼团价格
function productActivePrice(item) {
    const { activityModel, activityType, activityStatus, countDown, noticeSaleFlag } = item.activityEntity || {};

    // 有活动信息 && noticeSaleFlag（false不可售 true可售） 预售期不可售 && activityStatus 活动未开始
    if (item.activityEntity && noticeSaleFlag && activityStatus == 2) {
        return <div className={st['product_price_tag']}>
            <div className={st['product_active_price_box']}>
                <div className={st['product_active_price']}>
                    <span>{activityModel == 2 ? '拼团价' : '活动价'} ¥</span>
                    <span>{item.activityEntity?.activityPrice / 100}</span>
                </div>
            </div>
        </div>
    } else {
        return ''
    }
}
// 商品图片tag
function productImgTag(item, upDataProductInfo) {
    const { activityModel, activityType, activityStatus, noticeSaleFlag,countDown, saleTimeMsg } = item.activityEntity || {};
    const { productId } = item;

    // activityModel  活动方式 2拼团活动 3限时限量 10 定金活动
    // activityType  '1限时，2限量，3限时限量，默认限时' 拼团类型  1-普通拼团
    // activityStatus 1-进行中  2-预约中  3-未开始
    // noticeSaleFlag 预告期不可售
    // saleTimeMsg 预告期固定文案

    if (activityStatus == 2 && saleTimeMsg) { // 拼团活动未开始且没有倒计时
        return <div className={st['pin_tuan_not_started']}>{item.activityEntity?.saleTimeMsg}</div>
    } else if (activityModel == 2 && activityStatus == 2 && countDown) { // 拼团活动未开始
        return <div className={st['pin_tuan_not_started']}>距离拼团活动开始：
            <CountDown key="1" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    } else if (activityModel == 2 && activityStatus == 1 && countDown) { // 距离拼团活动结束
        return <div className={st['pin_tuan_end']}>
            距离拼团活动结束：
            <CountDown key="2" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    } else if (activityModel == 2 && activityStatus == 1) { // 拼团进行中
        return <div className={st['pin_tuan_underway']}>拼团进行中</div>
    } else if (activityModel == 3 && activityType == 2 && activityStatus == 1) { // 限量活动抢购中（展示剩余数量）
        return <div className={st['xianliang_img_tag']}>
            <span>抢购中</span>
            <span>剩余{item.activityEntity?.limitCount}个优惠名额</span>
        </div>
    } else if (activityModel == 3 && activityStatus == 1 && countDown) { // 限量、限时限量活动进行中（有倒计时，展示结束倒计时）
        return <div className={st['pin_tuan_end']}>
            距离活动结束：
            <CountDown key="3" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    } else if (activityModel == 3 && activityStatus == 1 && !countDown) { // 限量、限时限量活动进行中 (没有倒计时)
        return <div className={st['pin_tuan_underway']}>抢购中</div>
    } else if (activityModel == 3 && (activityType == 1 || activityType == 3) && activityStatus == 2 && countDown) { // 限量、限时限量活动未开始（展示开始倒计时）
        return <div className={st['pin_tuan_not_started']}>距离活动开始：
            <CountDown key="4" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    } else if ( activityModel == 10 && activityStatus == 2 && countDown ){
        return <div className={st['pin_tuan_not_started']}>距预定活动开始：
            <CountDown key="4" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    } else if ( activityModel == 10 && activityStatus == 1 && countDown ) {
        return <div className={cn({
            [st['pin_tuan_end']]:true
        })}>距离定金结束：
            <CountDown key="4" endTime={countDown / 1000} endTimeFun={
                () => {
                    upDataProductInfo()
                }
            } />
        </div>
    }
}

/**
 * productInfo: 商品信息
 * tabName: 商品详情页 面包屑当前 名称
 * toProductPath: 跳转商品路径
 */
export default observer(function Product({ productInfo = {}, className, tabName, toProductPath, shangchengBusinessFlag, ...props}) {
    const [store] = useState(() => new productStore())
    const { api, user, isZhumavip,sensorsLog } = useStore()
    // 商品信息
    const { product_info = {}, mybusinessType, setProductInfo } = store;
    // 活动信息
    const { productId = null } = store?.product_info;

    useEffect(() => {
        setProductInfo(productInfo);
    }, [productInfo])

    // 面包屑，跳转老项目的商品详情
    let tabList = tabName ? [
        {
            name: tabName,
            href: location.pathname + location.search
        }
    ] : null;

    // 更新商品数据接口
    const { loading, run, runAsync } = useRequest(() => user.get(productRefresh, { productId }), {
        manual: true, // 手动请求
        onSuccess: (res) => {
            setProductInfo(res.data);
        }
    });

    //Link的点击事件用于商品埋点
    return <Link
        className={cn(st['product_item'], st[isZhumavip() ? 'zhuma_theme_style' : 'zhonghe_theme_style'], className)}
        {...props}
        to={toProductPath ? toProductPath : `/${mybusinessType}/${(productInfo.productTypeId == user.productTypeId) ? 'openclass' : 'wangshou'}/${productId}?productId=${productId}&tab=${encodeURIComponent(JSON.stringify(tabList))}`}
        useorigin={false}
        onClick={() => {
            if (shangchengBusinessFlag) {
                sensorsLog('homePageClick', {
                    fakaoQuestionType : undefined,
                    homePageFeatures: shangchengBusinessFlag === 'fashuo' ? '查看法硕商品' : '查看法考商品'
                })
            }
        }}
    >
        <div className={st['product_img']}>
            <div className={st['product_img_box']}>
                <img className={st['thumbnail']} src={product_info?.detailPage} alt="" />
                {
                    product_info?.activityEntity?.detailMarkingMap ?
                        <img className={st['detail_marking_map']} src={product_info?.activityEntity?.detailMarkingMap} alt="" />
                        : ''
                }
            </div>
            <div className={st['product_img_tag']}>
                {
                    // 拼团价格
                    productActivePrice(product_info)
                }
                {
                    // 商品图片tag 倒计时、活动开始、结束时间
                    productImgTag(product_info, runAsync)
                }
            </div>
        </div>
        <div className={st['product_title']}>
            {
                productTag(product_info)
            }
            <p>{product_info?.title}</p>
        </div>
        <p className={st['product_describe']}>{ product_info?.sellPoint }</p>
        {/* {
            product_info?.saleModel == 0 ?
                // 公开课展示tag
                <div className={st['oci_sf']}>
                    {
                        product_info?.tagList.length > 0 ?
                            product_info?.tagList.map((itm, idx, self) => {
                                return (
                                    <span key={idx}>
                                        {itm.value}
                                        {idx < (self.length - 1) ? '+' : ''}
                                    </span>
                                )
                            })
                            : ''
                    }
                </div>
                : <p className={st['product_describe']}>{
                    product_info?.sellPoint
                }</p>
        } */}
        <div className={st['product_price']}>
            {

                product_info?.saleModel == 0 ?
                    <div className={st['public_product']}>
                        免费
                    </div>
                    :
                    <div className={st['price']} onClick={(() => {
                        console.log(product_info,'product_infoproduct_info')
                    })}>
                        <span>¥</span>
                        { product_info?.activityEntity?.sellingPrice ?
                            <span>{product_info?.activityEntity?.sellingPrice/100}</span>
                            :
                            <span>{product_info?.sellingPrice && product_info?.sellingPrice / 100}</span>
                        }
                      {/*// activityModel  活动方式 2拼团活动 3限时限量 10定金活动*/}
                      {/*activityStatus = '' // 1-进行中  2-预约中  3-未开始 不可售的*/}
                      {/*noticeSaleFlag 不可售 */}
                        { product_info?.activityEntity?.activityModel == 10 && (product_info?.activityEntity.activityStatus == 2  || product_info?.activityEntity.activityStatus == 1) && !product_info?.activityEntity?.noticeSaleFlag ? (<div className={st['yudingjia']}>
                            预定价
                        </div>)
                        :''
                        }
                    </div>

            }
            <div className={st['people_buy']}>
                {product_info?.activityEntity?.saleCountMsg ? product_info?.activityEntity?.saleCountMsg : product_info?.saleCountMsg}
            </div>
        </div>
    </Link>
})
